<template>
  <OnexText
    id="years_display"
    type="number"
    :aria-label="'years_display'"
    v-model="years"
    label=""
    :suffix="displaySuffix"
    class="text-center font-size--24 color-transparent pa-0 ma-0 no-labels"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { OnexText } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'YearsDisplay',
  components: {
    OnexText,
  },
  props: {
    modelValue: {
      type: [String, Number],
      required: true,
      default: '0',
    },
  },
  data: () => ({
    years: '0',
  }),
  computed: {
    displaySuffix() {
      if (this.years === '') {
        return '';
      }
      return this.years > 1 ? this.$t('years') : this.$t('year');
    },
  },
  watch: {
    modelValue(value) {
      this.years = String(value);
    },
  },
  mounted() {
    this.years = String(this.modelValue);
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.pr-50 {
  :deep(input) {
    padding-right: 48px !important;
  }
}
.pr-62 {
  :deep(input) {
    padding-right: 58px !important;
  }
}

:deep(div.v-text-field__slot) {
  z-index: 2;
}

:deep(div.v-input__append-inner) {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  & > span {
    width: 100%;
    text-align: center;
  }
}
</style>
<style lang="scss">
label[for='years_display'] {
  display: none;
}
#years_display {
  padding-top: 0;
}
</style>
